'use client';

import { useEffect } from 'react';
import { registerClientProfilerPage } from '@/src/lib/clientProfiler';

export function ClientProfilerRegistrar({ pageName }: { pageName: string }) {
  useEffect(() => {
    registerClientProfilerPage(pageName);
  }, [pageName]);

  return null;
}
